<template>
  <div class="content">
    <div ref="search_d" class="top-bar">
      <div>投标项目-自定义字段</div>
      <el-button icon="el-icon-plus" type="primary" class="add-btn" @click="addKeyActon">新增字段</el-button>
    </div>
    <el-table border ref="multipleTable" :data="customFields" tooltip-effect="dark" style="width: 100%;" :height="height"
      stripe :header-cell-style="{ background: 'rgb(238,241,246)' }">
      <el-table-column fixed prop="fieldName" label="字段名称" min-width="150" align="center">
        <template slot-scope="scope">
          <el-link :underline="false" type="primary" @click="editKeyAction(scope.row)">{{ scope.row.fieldName }}<i
              class="el-icon-edit-outline" style="margin-left:4px;"></i></el-link>
        </template>
      </el-table-column>

      <el-table-column prop="fieldName" label="字段类型" min-width="80" align="center">
        <template slot-scope="scope">
          <el-tag size="small" :type="scope.row.valueType === 'text' ? ''
            : scope.row.valueType === 'number' ? 'success'
              : scope.row.valueType === 'date' ? 'info'
                : scope.row.valueType === 'select' ? 'warning'
                  : scope.row.valueType === 'attachment' ? 'danger' : ''">
            <span v-if="scope.row.valueType == 'text'">文本</span>
            <span v-if="scope.row.valueType == 'number'">数值</span>
            <span v-if="scope.row.valueType == 'date'">日期</span>
            <span v-if="scope.row.valueType == 'select'">选择</span>
            <span v-if="scope.row.valueType == 'attachment'">附件</span>
          </el-tag>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="detail" label="提示文字" min-width="120" align="center">
      </el-table-column> -->

      <el-table-column prop="unit" label="单位" min-width="60" align="center">
      </el-table-column>

      <el-table-column prop="defaultValueEdited" label="默认值" min-width="100" align="center">
        <template slot-scope="scope">
          <span
            v-if="scope.row.valueType == 'date' && scope.row.defaultValueEdited != null && scope.row.defaultValueEdited != ''">{{
              scope.row.defaultValueEdited | dataFormat }}</span>
          <span v-if="scope.row.valueType != 'date'">{{ getSelectValueName(scope.row) }}</span>
        </template>
      </el-table-column>

      <el-table-column prop="valueLength" label="字段长度" min-width="70" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.valueLength }} </span>
        </template>
      </el-table-column>

      <el-table-column prop="columnWidth" label="宽度" min-width="60" align="center">
      </el-table-column>

      <el-table-column prop="sort" label="排序" width="60" align="center">
      </el-table-column>

      <el-table-column prop="isSystem" label="字段属性" width="80" align="center">
        <template slot-scope="scope">
          <el-tag size="small" :type="scope.row.isSystem == 1 ? 'info' : 'primary'">
            {{ scope.row.isSystem == 1 ? '系统' : '自定义' }}
          </el-tag>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="status" label="启用" width="70" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.status" :active-value="1" :inactive-value="0" active-color="#13ce66"
            inactive-color="#f1f2f4" @change="switchChange(scope.row, 'status')"></el-switch>
        </template>
      </el-table-column> -->

      <el-table-column prop="required" label="必填" width="70" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.required" :active-value="1" :inactive-value="0" active-color="#13ce66"
            inactive-color="#f1f2f4" @change="switchChange(scope.row, 'required')"></el-switch>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="isOnly" label="唯一" width="70" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isOnly" :active-value="1" :inactive-value="0" active-color="#13ce66"
            inactive-color="#f1f2f4" @change="switchChange(scope.row, 'isOnly')"></el-switch>
        </template>
      </el-table-column> -->

      <el-table-column prop="isListPageShow" label="列表页展示" width="90" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isListPageShow" :active-value="1" :inactive-value="0" active-color="#13ce66"
            inactive-color="#f1f2f4" @change="switchChange(scope.row, 'isListPageShow')"></el-switch>
        </template>
      </el-table-column>

      <!-- <el-table-column prop="isDetailPageShow" label="详情页展示" width="90" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isDetailPageShow" :active-value="1" :inactive-value="0" active-color="#13ce66"
            inactive-color="#f1f2f4" @change="switchChange(scope.row, 'isDetailPageShow')"></el-switch>
        </template>
      </el-table-column> -->

      <el-table-column prop="isEditPageShow" label="编辑页展示" width="90" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.isEditPageShow" :active-value="1" :inactive-value="0" active-color="#13ce66"
            inactive-color="#f1f2f4" @change="switchChange(scope.row, 'isEditPageShow')"></el-switch>
        </template>
      </el-table-column>

      <el-table-column fixed="right" label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-link icon="el-icon-delete" :underline="false" style="color: red;" type="primary"
            @click="deleteKeyAction(scope.row)" v-if="scope.row.isSystem == 0">删除</el-link>
          <span style="color: #999" v-else>不可删除</span>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer :visible.sync="showAddAlert" direction="rtl" size="70%" :with-header="false" :destroy-on-close="true"
      :modal="false">
      <el-container class="right-drawer-container" direction="vertical">
        <el-header class="drawer-header">
          <div style="font-weight: 500;font-size: 16px;">{{ !addForm.id ? '新增字段' : '编辑字段' }}</div>
          <div style="display: flex;">
            <el-button @click="showAddAlert = false">取 消</el-button>
            <el-button type="primary" @click="saveFormAction">保 存</el-button>
          </div>
        </el-header>
        <!-- 表单滚动区域 -->
        <el-main class="drawer-main-scroll">
          <!-- 分组1：基础信息 -->
          <div class="form-group-title">基础信息</div>
          <el-form ref="add-form" class="add-form" label-position="top" label-width="110px">
            <el-form-item label="字段名称" class="add-form-item" required>
              <el-input v-model="addForm.fieldName" placeholder="请输入字段名称"></el-input>
            </el-form-item>
            <el-form-item label="字段编码（唯一）" class="add-form-item" required>
              <el-input v-model="addForm.fieldCode" placeholder="请输入字段code"></el-input>
            </el-form-item>
            <el-form-item label="提示文字" class="add-form-item">
              <el-input v-model="addForm.detail" placeholder="请输入提示文字"></el-input>
            </el-form-item>
            <el-form-item label="字段类型" class="add-form-item" required>
              <el-select v-model="addForm.valueType" placeholder="请选择字段类型" @change="valueTypeSelectChange">
                <el-option v-for="item in customCodeList" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单位" class="add-form-item"
              v-if="addForm.valueType == 'text' || addForm.valueType == 'number'">
              <el-input v-model="addForm.unit" placeholder="元、万元、分等（非必填）"></el-input>
            </el-form-item>
          </el-form>

          <!-- 分组2：字段属性配置 -->
          <div class="form-group-title">字段属性配置</div>
          <el-form ref="add-form" class="add-form" label-position="top" label-width="110px">
            <el-form-item label="排序(越大越靠前)" class="add-form-item" required>
              <el-input v-model="addForm.sort" placeholder="请输入排序"></el-input>
            </el-form-item>
            <el-form-item label="列宽" class="add-form-item" required>
              <el-input v-model="addForm.columnWidth" placeholder="请输入列宽"></el-input>
            </el-form-item>
            <el-form-item label="字段长度" class="add-form-item" v-if="addForm.valueType == 'text'">
              <el-input v-model="addForm.valueLength" placeholder="0字符"></el-input>
            </el-form-item>
            <el-form-item label="默认值" class="add-form-item">
              <el-input v-model="addForm.defaultValueEdited" placeholder="请输入默认值（非必填）"
                v-if="addForm.valueType == 'text' || addForm.valueType == 'number'"></el-input>
              <el-date-picker v-model="addForm.defaultValueEdited" type="datetime" placeholder="请选择默认时间（非必填）"
                v-else-if="addForm.valueType == 'date'"></el-date-picker>
              <el-select v-model="addForm.defaultValueEdited" placeholder="请选择默认选项（非必填）"
                v-else-if="addForm.valueType == 'select'">
                <el-option v-for="item in selectValueList" :key="item.code" :label="item.name" :value="item.code">
                </el-option>
              </el-select>
              <el-input v-model="addForm.defaultValueEdited" placeholder="请输入默认值（非必填）" v-else></el-input>
            </el-form-item>
          </el-form>

          <!-- 分组3：校验与页面展示配置 -->
          <div class="form-group-title">校验与页面展示配置</div>
          <el-form ref="add-select-form" label-position="left">
            <el-row :gutter="20">
              <!-- <el-col :span="8">
                <el-form-item label="启用" class="add-select-form-item">
                  <el-switch v-model="addForm.status" :active-value="1" :inactive-value="0" active-color="#13ce66"
                    inactive-color="#f1f2f4"></el-switch>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="必填" class="add-select-form-item">
                  <el-switch v-model="addForm.required" :active-value="1" :inactive-value="0" active-color="#13ce66"
                    inactive-color="#f1f2f4"></el-switch>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="唯一" class="add-select-form-item">
                  <el-switch v-model="addForm.isOnly" :active-value="1" :inactive-value="0" active-color="#13ce66"
                    inactive-color="#f1f2f4"></el-switch>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="列表页展示" class="add-select-form-item">
                  <el-switch v-model="addForm.isListPageShow" :active-value="1" :inactive-value="0" active-color="#13ce66"
                    inactive-color="#f1f2f4"></el-switch>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="8">
                <el-form-item label="详情页展示" class="add-select-form-item">
                  <el-switch v-model="addForm.isDetailPageShow" :active-value="1" :inactive-value="0"
                    active-color="#13ce66" inactive-color="#f1f2f4"></el-switch>
                </el-form-item>
              </el-col> -->
              <el-col :span="8">
                <el-form-item label="编辑页展示" class="add-select-form-item">
                  <el-switch v-model="addForm.isEditPageShow" :active-value="1" :inactive-value="0" active-color="#13ce66"
                    inactive-color="#f1f2f4"></el-switch>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>

          <!-- 分组4：下拉选项配置（仅选择类型select才显示） -->
          <div class="form-group-title" v-if="addForm.valueType == 'select'">下拉选项配置</div>
          <div class="selectValue-box" v-if="addForm.valueType == 'select'">
            <div class="selectValue-title">
              <div style="width: 30%;text-align: center;">选项名称</div>
              <div style="width: 25%;text-align: center;">选项数值（唯一）</div>
              <div style="width: 25%;text-align: center;">标签颜色</div>
              <div style="width: 20%;text-align: center;">操作</div>
            </div>
            <div class="selectValue-list">
              <div class="sellectValue-item" v-for="(item, index) in selectValueList" :key="item.code">
                <div style="width: 30%;border-right: 1px solid #ddd;padding: 10px 0;text-align: center;">{{ item.name }}
                </div>
                <div style="width: 25%;text-align: center;border-right: 1px solid #ddd;padding: 10px 0;">{{ item.code }}
                </div>
                <div
                  style="width: 25%;border-right: 1px solid #ddd;padding: 10px 0;display: flex;justify-content: center;">
                  <span :style="{
                    display: 'inline-block',
                    width: '20px',
                    height: '20px',
                    borderRadius: '3px',
                    background: item.color,
                    border: '1px solid #ccc'
                  }">
                  </span>
                </div>

                <div style="display: flex;gap:10px;width:20%;justify-content:center;padding: 10px 0;">
                  <el-link icon="el-icon-edit-outline" :underline="false" type="primary"
                    @click="editValueAction(index)">编辑</el-link>
                  <el-link icon="el-icon-delete" :underline="false" type="danger"
                    @click="deleteValueAction(index)">删除</el-link>
                </div>
              </div>
            </div>
            <el-link class="selectValue-addBtn" type="primary" :underline="false" @click="addSelectValueAction">
              + 添加选项值
            </el-link>
          </div>

        </el-main>
      </el-container>
    </el-drawer>

    <el-dialog :title="addSelectValueType == 0 ? '新增选项值' : '编辑选项值'" :visible.sync="showAddSelectValueAlert" center
      :modal="true" width="500px">
      <el-form ref="add-form" class="add-select-form" label-position="top" label-width="110px">
        <el-form-item label="选项名称" class="add-form-item">
          <el-input v-model="editSelelctValue.name"></el-input>
        </el-form-item>
        <el-form-item label="选项数值（唯一）" class="add-form-item">
          <el-input v-model="editSelelctValue.code"></el-input>
        </el-form-item>
        <!-- 新增颜色选择 + 颜色编码输入框 -->
        <el-form-item label="标签颜色" class="add-form-item">
          <div style="display:flex;align-items:center;gap:10px;">
            <el-color-picker v-model="editSelelctValue.color" show-alpha></el-color-picker>
            <el-input v-model="editSelelctValue.color" placeholder="色值 #ffffff / rgba(255,255,255,1)"
              style="flex:1"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddSelectValueAlert = false">取 消</el-button>
        <el-button type="primary" @click="saveSelectValueAction">保 存</el-button>
      </div>
    </el-dialog>



  </div>
</template>


<script>
export default {
  data() {
    return {
      customFields: [],

      showAddAlert: false,
      showAddSelectValueAlert: false,

      addForm: {
        valueType: 'text'
      },

      addKeyType: 0,
      addSelectValueType: 0,
      editSelelctIndex: 0,
      editSelelctValue: {
        name: '',
        code: ''
      },

      customCodeList: [
        {
          name: '文本类型',
          code: 'text',
        }, {
          name: '日期类型',
          code: 'date',
        }, {
          name: '数值类型',
          code: 'number',
        }, {
          name: '下拉列表',
          code: 'select',
        }, {
          name: '附件类型',
          code: 'attachment',
        },
      ],

      selectValueList: [],
      height: window.innerHeight - 140, //表格高度
      headerHeight: 0,
      loading: false
    };
  },

  created() {
    this.loadFieldList()
  },

  mounted() {
    this.$nextTick(() => {
      // 获取定义ref属性 和 元素高度
      this.headerHeight = this.$refs.search_d.offsetHeight;
      window.addEventListener('resize', this.getHeight())
    });

    // this.loadFieldList();
  },

  methods: {
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - this.headerHeight - 140;
    },

    switchChange(row, key) {
      console.log('switchChange')
      let that = this
      this.$http.post('customColumnFiled/save', row)
        .then(function (res) {
          if (res.data.code == 200) {
            that.loadFieldList()
          } else {
            that.$message.error(res.data.msg)
            return
          }
        });
    },

    getSelectValueName(row) {
      if (row.valueType == 'select' && row.valueRange != null && row.valueRange != "" && row.defaultValueEdited != null && row.defaultValueEdited != "") {
        let valueRange = JSON.parse(row.valueRange)
        let colorRange = row.colorRange ? JSON.parse(row.colorRange) : {}
        const name = valueRange[row.defaultValueEdited]
        const color = colorRange[row.defaultValueEdited] || ''
        return name
      }
      return row.defaultValueEdited;
    },


    //加载字段配置列表
    loadFieldList() {
      var that = this;
      this.$http
        .post("/customColumnFiled/queryList", {
          customType: 'bidProject'
        })
        .then(function (res) {
          if (res.data.code == 200) {
            that.customFields = res.data.data;
          } else {
            that.$message.error(res.data.msg)
          }
        });
    },

    //切换字段类型
    valueTypeSelectChange(e) {
      this.addForm.valueType = e

      this.addForm.defaultValueEdited = null

      if (e == 'text') {
        this.addForm.valueLength = 20;
      } else {
        this.addForm.valueLength = null;
      }
    },

    //新增字段
    addKeyActon() {
      let customFieldId = this.generateUniqueCode()
      let fieldCode = this.generateUniqueCode()
      this.addForm = {
        customFieldId: customFieldId,
        customType: 'bidProject',
        fieldName: '',
        fieldCode: fieldCode,
        valueType: 'text',
        valueLength: 20,
        valueRange: null,
        colorRange: null, //新增
        required: 0,
        detail: '',
        isSystem: 0,
        isOnly: 0,
        columnWidth: 100,
        sort: 0,
        status: 1,
        unit: null,
        defaultValueEdited: null,
        isListPageShow: 1,
        isDetailPageShow: 1,
        isEditPageShow: 1,
        isSearchShow: 0,
        createName: localStorage.getItem("userName"),
      }
      this.addKeyType = 0
      this.selectValueList = []
      this.showAddAlert = true
    },


    //保存字段
    saveFormAction() {
      this.showAddAlert = false
      if (this.addForm.valueType == 'select' && this.selectValueList.length != 0) {
        const valueRange = this.selectValueList.reduce((acc, item) => {
          acc[item.code] = item.name;
          return acc;
        }, {});
        // ======新增组装colorRange======
        const colorRange = this.selectValueList.reduce((acc, item) => {
          acc[item.code] = item.color || '';
          return acc;
        }, {});
        this.addForm.valueRange = JSON.stringify(valueRange)
        this.addForm.colorRange = JSON.stringify(colorRange)
      } else {
        this.addForm.valueRange = null
        this.addForm.colorRange = null
      }

      if (this.addForm.valueType == 'date' && this.addForm.defaultValueEdited != null) {
        this.addForm.defaultValueEdited = this.addForm.defaultValueEdited;
      }
      let that = this
      let url = '/customColumnFiled/save';
      this.$http.post(url, this.addForm)
        .then(function (res) {
          if (res.data.code == 200) {
            that.loadFieldList()
          } else {
            that.$message.error(res.data.msg)
            return
          }
        });
    },

    //编辑字段
    editKeyAction(row) {
      this.addForm = {
        ...row
      }
      console.log(this.addForm.valueRange);
      if (this.addForm.valueType == 'select' && this.addForm.valueRange != null && this.addForm.valueRange != '') {
        let valueRange = JSON.parse(this.addForm.valueRange)
        //====新增读取colorRange====
        let colorRange = this.addForm.colorRange ? JSON.parse(this.addForm.colorRange) : {}
        const valuesArray = Object.values(valueRange);
        const keysArray = Object.keys(valueRange);
        const selectValueList = [];
        for (let index = 0; index < valuesArray.length; index++) {
          const value = valuesArray[index];
          const key = keysArray[index];
          let valueData = {
            name: value,
            code: key,
            color: colorRange[key] || '' // 取不到颜色赋值空字符串
          }
          selectValueList.push(valueData)
        }
        this.selectValueList = selectValueList;
        console.log(JSON.stringify(selectValueList))
      } else {
        this.selectValueList = [];
      }
      if (this.addForm.valueType == 'date' && this.addForm.defaultValueEdited != null && this.addForm.defaultValueEdited != "") {
        let defaultdate = new Date(this.addForm.defaultValueEdited * 1000)
        this.addForm.defaultValueEdited = defaultdate
      }
      this.addKeyType = 1
      this.showAddAlert = true
    },

    //删除字段
    deleteKeyAction(row) {
      const h = this.$createElement;
      this.$msgbox({
        title: '提醒',
        message: h('p', null, [
          h('span', null, '确认删除此字段吗？'),
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true;
            instance.confirmButtonText = '执行中...';

            var that = this;
            this.$http
              .post("/customColumnFiled/delete", {
                id: row.id
              })
              .then(function (res) {
                instance.confirmButtonLoading = false;
                done();

                if (res.data.code != 200) {
                  that.$message.error(res.data.msg)
                }

                that.loadFieldList();
              });
          } else {
            done();
          }
        }
      }).then(action => {

      });
    },

    //添加选项值
    addSelectValueAction() {
      this.addSelectValueType = 0

      let code = this.generateUniqueCode()
      console.log(code)
      this.editSelelctValue = {
        name: '',
        code: code,
        color: '',
      }
      this.showAddSelectValueAlert = true
    },

    //获取选项值code
    generateUniqueCode() {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      const charactersLength = characters.length;
      for (let i = 0; i < 10; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },

    //保存选项值
    saveSelectValueAction() {
      this.showAddSelectValueAlert = false

      if (this.addSelectValueType == 0) {
        this.selectValueList.push(this.editSelelctValue)
      } else {
        let editSelelctValue = this.selectValueList[this.editSelelctIndex]

        editSelelctValue.name = this.editSelelctValue.name
        editSelelctValue.code = this.editSelelctValue.code
        editSelelctValue.color = this.editSelelctValue.color
      }
    },

    //编辑选项值
    editValueAction(index) {
      this.addSelectValueType = 1
      this.editSelelctIndex = index

      let editSelelctValue = this.selectValueList[index]
      this.editSelelctValue = {
        ...editSelelctValue
      }

      this.showAddSelectValueAlert = true
    },

    //删除选项值
    deleteValueAction(index) {
      this.selectValueList.splice(index, 1)
    },

  },
};
</script>

<style scoped lang="less">
.content {
  padding: 10px;
  background: #fff;
}

.nav-title {
  font-size: 17px;
  font-weight: 500;
}

.top-bar {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
}

.add-form {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  gap: 0 30px;

  .add-form-item {
    width: 30%;
    box-sizing: border-box;

    .el-input {
      width: 100%;
    }

    .el-select {
      width: 100%;
    }
  }
}

.add-select-form {
  display: flex;
  flex-wrap: wrap;
  align-content: center;
  gap: 0 30px;

  .add-form-item {
    width: 100%;
    box-sizing: border-box;

    .el-input {
      width: 100%;
    }

    .el-select {
      width: 100%;
    }
  }
}

.selectValue-box {
  border: 1px solid #eee;

  .selectValue-title {
    display: flex;
    font-weight: 500;
    line-height: 30px;
    border-bottom: 1px solid #eee;
    justify-content: space-between;
    background-color: #f1f3f4;
    padding: 0 10px;
  }

  .selectValue-addBtn {
    margin-top: 10px;
    margin-left: 10px;
    margin-bottom: 10px;
    padding: 5px 10px;
    border-radius: 5px;
    border: 1px solid #409eff;
  }

  .selectValue-list {
    display: flex;
    flex-direction: column;
    padding: 0 10px;

    .sellectValue-item {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #ddd;
    }
  }
}

.right-drawer-container {
  padding: 0 24px;
  height: 100%;
}

.drawer-main-scroll {
  height: calc(100% - 60px);
  overflow-y: auto;
  padding: 20px 0;
}

.drawer-header {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0;
  border-bottom: 1px solid #e6e6e6;
  background: #fff;
}

.drawer-header .el-button {
  margin-left: 10px;
}

/* 表单分组标题 */
.form-group-title {
  font-size: 15px;
  font-weight: bold;
  color: #303133;
  margin: 16px 0 8px;
  padding-left: 8px;
  border-left: 4px solid #409eff;
  line-height: 28px;
}

.editForm {
  width: calc(100% - 30px);
}
</style>

